export { SearchDatabase } from './SearchDatabase.component';
